import { Dialog, useDialog } from "@fpsoftware/mvp";
import { zodResolver } from "@hookform/resolvers/zod";
import { useQueryClient } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { TbDeviceFloppy } from "react-icons/tb";
import { AddressNewBodySchema, type State } from "shared";
import { Api } from "@/api.config";
import { Button } from "@/components/Button";
import { TextField } from "@/components/form/TextField";
import { QueryKeys } from "@/LinkGen";

interface AddAddressDialogProps {
  onConfirm(id: number): unknown;
}

export const AddAddressDialog = (props: AddAddressDialogProps) => {
  const dialog = useDialog();

  const { handleSubmit, formState, control } = useForm({
    resolver: zodResolver(AddressNewBodySchema),
    defaultValues: {
      line1: "",
      line2: "",
      city: "",
      state: "" as State,
      zipCode: "",
    },
  });
  const queryClient = useQueryClient();

  const onSubmit = handleSubmit(async (values) => {
    const created = await Api.AddressNew(values).then((res) => res.data);
    queryClient.setQueryData(QueryKeys.Address(created.ID), () => created);
    props.onConfirm(created.ID);
    dialog.close();
  });

  return (
    <form onSubmit={onSubmit}>
      <Dialog.Header>Create a new address</Dialog.Header>
      <Dialog.Body>
        <TextField
          label="Address line 1"
          placeholder="1234 Main St"
          autoFocus
          control={control}
          name="line1"
          required
        />
        <TextField
          label="Address line 2"
          placeholder="Apt 101"
          control={control}
          name="line2"
        />
        <TextField
          label="City"
          placeholder="Anytown"
          control={control}
          name="city"
          required
        />
        <TextField
          label="State"
          placeholder="CO"
          control={control}
          name="state"
          required
        />
        <TextField
          label="ZIP Code"
          placeholder="90210-0001"
          control={control}
          name="zipCode"
          required
        />
      </Dialog.Body>
      <Dialog.Footer>
        <Button
          icon={TbDeviceFloppy}
          type="submit"
          loading={formState.isSubmitting}
        >
          Save
        </Button>
      </Dialog.Footer>
    </form>
  );
};
